export const debugLogResponse = async (label: string, resp: Response) => {
	const clone = resp.clone();
	let body: any;
	try {
		body = await clone.json();
	} catch {
		try {
			body = await clone.text();
		} catch {
			body = '<no body>';
		}
	}
	const headers: Record<string, string> = {};
	resp.headers.forEach((v, k) => (headers[k] = v));
	console.debug(`[${label}] –`, {
		url: resp.url,
		status: resp.status,
		ok: resp.ok,
		headers,
		body,
	});
	return body;
};
